module.exports = __webpack_public_path__ + "static/media/reddit-script.e44d48cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/reddit-script.jpg
// module id = 91
// module chunks = 0